import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const EmojiLineSadIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "EmojiLineSad",
    children: /*#__PURE__*/_jsx("path", {
      d: "M16 30C8.27 30 2 23.73 2 16S8.27 2 16 2s14 6.27 14 14-6.27 13.99-14 14m0-26C9.37 4 4 9.37 4 16s5.37 12 12 12 12-5.37 12-12c0-6.62-5.37-11.99-12-12m6.48 9.87c0 1.09-.88 1.97-1.97 1.97s-1.97-.88-1.97-1.97.88-1.97 1.97-1.97 1.97.88 1.97 1.97m-10.99-1.99c1.09 0 1.97.88 1.97 1.97s-.88 1.97-1.97 1.97-1.97-.88-1.97-1.97.88-1.97 1.97-1.97m-2.32 9.57c1.84-1.56 4.21-2.54 6.82-2.63h.02c2.62.08 5 1.06 6.85 2.65h-.01c.2.17.32.42.32.71 0 .24-.09.46-.23.63a.883.883 0 0 1-1.29.09 9.42 9.42 0 0 0-5.61-2.15h-.02c-2.16.09-4.11.9-5.66 2.18h.02c-.16.13-.37.22-.6.22-.28 0-.53-.13-.69-.33a1.03 1.03 0 0 1 .1-1.36Z"
    })
  }));
};